export default __webpack_public_path__ + "static/media/image-check-filled.34e3ff8a.svg";